/**
 * The app's ONE floppy disk.
 *
 * `Builder planu - tydzien - programator.dc.html`'s own 16×16 glyph at its `stroke-width: 1.7`,
 * promoted out of `pages/plan-builder/ui/BuilderTopBar.tsx` on 17 September 2026 when the survey
 * editor's save became the same square. `pages/reports` had drawn a second floppy of its own at a
 * 24-unit scale and stroke 2 (`ReportIcons`' `SaveIcon`), so the shelf's dialog and the builder's
 * bar said „save" with two different drawings; that one is deleted and its three callers read this.
 *
 * `aria-hidden`, like every glyph in this app: a save control carries its whole name on the button —
 * `aria-label` where there is no visible word, the word itself where there is.
 *
 * The SIZE belongs to the caller, because the three squares that wear it are not the same square.
 * The default is `saveButton.module.css`'s 16px, which is the mock's.
 */

import save from './saveButton.module.css';

export function SaveGlyph({ className }: { readonly className?: string }) {
  return (
    <svg
      className={className ?? save.glyph}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.5 3.5h9L16.5 6.5v10a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1z" />
      <path d="M6.5 3.5v4h6v-4" />
      <rect x="6.5" y="11" width="7" height="6.5" />
    </svg>
  );
}
